import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import { useSentry } from './services/sentry'

import { definePreset } from '@primeuix/themes';
import PrimeVue from 'primevue/config';
import Aura from '@primeuix/themes/aura';

import App from './App.vue'
import router from './router'

import Button from 'primevue/button';
import InputText from 'primevue/inputtext';
import Password from 'primevue/password';
import Message from 'primevue/message';
import InputGroup from 'primevue/inputgroup';
import IconField from 'primevue/iconfield';
import InputIcon from 'primevue/inputicon';
import Tag from 'primevue/tag'
import ToastService from 'primevue/toastservice';
import ConfirmationService from 'primevue/confirmationservice';
import { initYupLocale } from '@/services/yupConfig';

const app = createApp(App)

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)
useSentry(app, router)
app.use(pinia)
app.use(router)

initYupLocale();

const MyPreset = definePreset(Aura, {
    semantic: {
        primary: {
            50: '#f2f6fc',
            100: '#e4ecf8',
            200: '#c9d9f1',
            300: '#9fc0e6',
            400: '#6d9fd8',
            500: '#134391',
            600: '#103a82',
            700: '#0e3173',
            800: '#0b2864',
            900: '#081f55',
            950: '#051646'
        },
        secondary: {
            50: '#f6fdf1',
            100: '#ecfbe3',
            200: '#d9f7c7',
            300: '#bff09f',
            400: '#9fe670',
            500: '#94C11F',
            600: '#84ad1c',
            700: '#749918',
            800: '#648515',
            900: '#547112',
            950: '#445d0e'
        },
        success: {
            50: '#f6fdf1',
            100: '#ecfbe3',
            200: '#d9f7c7',
            300: '#bff09f',
            400: '#9fe670',
            500: '#94C11F',
            600: '#84ad1c',
            700: '#749918',
            800: '#648515',
            900: '#547112',
            950: '#445d0e'
        }
    }
});

app.use(PrimeVue, {
    theme: {
        preset: MyPreset,
        options: {
            darkModeSelector: '.app-dark'
        }
    },
    locale: 'fr'
});

app.component('Button', Button);
app.component('InputText', InputText);
app.component('Password', Password);
app.component('Message', Message);
app.component('InputGroup', InputGroup);
app.component('IconField', IconField);
app.component('InputIcon', InputIcon);
app.component('Tag', Tag);

app.use(ToastService);
app.use(ConfirmationService);

app.mount('#app')
